import {styled} from 'common'
import RawButton from '@mui/material/Button'
import {paramCase} from 'change-case'

const Button = ({children, dataTestId, ...p}) => {
    return (
        <StyledButton
            data-test-id={`button-${paramCase(
                children?.toString() || dataTestId || 'undefined'
            )}`}
            {...p}>
            {children}
        </StyledButton>
    )
}
export default Button

const StyledButton = styled(RawButton)``
